/**
 * Landing URL per role.
 *
 * Extracted from `App.jsx` so Vite's Fast Refresh stays happy —
 * `App.jsx` is a component module and Fast Refresh requires
 * component modules to only export components. The old shape
 * (default-exporting `App` AND named-exporting this helper)
 * tripped React Refresh's "incompatible export" check, which made
 * every save in App.jsx fall back to a full page reload instead of
 * an HMR patch:
 *
 *   [vite] hmr invalidate /src/App.jsx Could not Fast Refresh
 *          ("landingFor" export is incompatible)
 *   [vite] page reload src/App.jsx
 *
 * Moving the helper out turns those page-reloads back into in-place
 * HMR updates, which is the difference between "edit a label →
 * instant" and "edit a label → full reload + lose scroll position +
 * lose dialog state".
 *
 * Mapping:
 *   super_admin   → /super-admin/dashboard
 *   company_admin → /dashboard
 *   sub_admin     → /dashboard   (shares the Admin panel; sidebar /
 *                                 page gates hide what they don't
 *                                 have ops for)
 *   user / unknown → /app
 */
export function landingFor(role) {
  if (role === 'super_admin') return '/super-admin/dashboard'
  if (role === 'company_admin') return '/dashboard'
  if (role === 'sub_admin') return '/dashboard'
  return '/app'
}

/** My Preferences lives beside Profile in each panel. */
export function preferencesPathFor(role) {
  if (role === 'super_admin') return '/super-admin/preferences'
  if (role === 'user') return '/app/preferences'
  return '/preferences'
}
